// extracted by mini-css-extract-plugin
export var modalBox = "F_vn";
export var backdrop = "F_vp";